import { Controller } from "@hotwired/stimulus";
import _ from "underscore";
import moment from "moment";
// stripe_payout
const csrfToken = document.querySelector("meta[name=\"csrf-token\"]")?.content || "";
let BANK_RULES, stripeApi, stripeFormData, options;
globalThis.ITOONS = globalThis.ITOONS || {};
globalThis.ITOONS.stripe_form_i18n = globalThis.ITOONS.stripe_form_i18n || {
  "account_number": "Account number",
  "routing_number": "Routing number",
  "bank_code": "Bank code",
  "branch_code": "Branch code",
  "transit_number": "Transit number",
  "institution_number": "Institution number",
  "format_varies_by_bank": "Format varies by bank",
  "bsb": "BSB",
  "error_message": "Invalid format",
  "clearing_code": "Clearing code",
  "sort_code": "Sort code",
  "must_match": "must match",
  "a_dash": "a dash",
  "digits": "digits",
  "digits_or_chars": "digits or A-Z chars"
};

export default class StripePayoutController extends Controller {
  initialize() {
    options = JSON.parse(this.element.dataset.options);
    BANK_RULES = options.bank_rules;
    globalThis.ITOONS.stripe_test_api_mode = options.stripe_test_mode;
    stripeApi = Stripe(options.api_publishable_key);
  }

  connect() {
    this.init(options);
  }

  i18n_label(key, default_value) {
    let translated = globalThis.ITOONS.stripe_form_i18n[key];
    if (translated) return translated;
    return key || default_value;
  }

  show_if(element, value) {
    if (value.format) {
      element.show();
    } else {
      element.hide();
      element.find("input").val("");
    }
  }

  update_bank_number_form(country) {
    let rule = BANK_RULES[country] || {};

    let rule_account_number = rule.account_number || {};
    let rule_routing_number = rule.routing_number || {};
    let rule_routing_1 = rule.routing_1 || {};
    let rule_routing_2 = rule.routing_2 || {};

    $(".bank-account-number label:first").text(this.i18n_label(rule_account_number.title, this.i18n_label("account_number", "Account number")));
    $(".bank-routing-number label:first").text(this.i18n_label(rule_routing_number.title, this.i18n_label("routing_number", "Routing number")));
    $(".bank-routing-1 label:first").text(this.i18n_label(rule_routing_1.title, this.i18n_label("routing_1", "Bank code")));
    $(".bank-routing-2 label:first").text(this.i18n_label(rule_routing_2.title, this.i18n_label("routing_2", "Branch code")));

    $(".bank-account-number input").attr("placeholder", this.i18n_label(rule_account_number.format, rule_account_number.format));
    $(".bank-routing-number input").attr("placeholder", rule_routing_number.format);
    $(".bank-routing-1 input").attr("placeholder", rule_routing_1.format);
    $(".bank-routing-2 input").attr("placeholder", rule_routing_2.format);

    this.show_if($(".bank-routing-number"), rule_routing_number);
    this.show_if($(".bank-routing-1"), rule_routing_1);
    this.show_if($(".bank-routing-2"), rule_routing_2);
    $("[phone_number]").attr("placeholder", rule.phone_number);
    $("#phone-placeholder").html("\"" + rule.phone_number + "\".");
  }

  getDateValue(name, datetype) {
    let selected_date = this.getValue(name);
    let value;
    switch (datetype) {
      case "day":
        value = moment(selected_date).date();
        break;
      case "month":
        value = moment(selected_date).month() + 1;
        break;
      case "year":
        value = moment(selected_date).year();
        break;
      default:
        value = 0;
    }
    return value;
  }

  getValue(name, valueType) {
    let value,
      item = stripeFormData.find(function (x) {
        return x.name === "stripe_account_form[" + name + "]";
      });
    if (item) {
      if (valueType === "int") {
        value = Number.parseInt(item.value);
      } else {
        value = item.value;
      }
    }
    return item ? value : null;
  }

  omitNullDeep(obj) {
    return _.reduce(obj, function (result, value, key) {
      if (_.isObject(value)) {
        result[key] = this.omitNullDeep(value);
      } else if (!_.isNull(value)) {
        result[key] = value;
      }
      return result;
    }.bind(this), {});
  }

  removeSpaces() {
    $(".bank-account-number, .bank-routing-number, .bank-routing-1, .bank-routing-2")
      .find("input:enabled").each(function () {
        let input = $(this),
          value = input.val().replaceAll(/\s+/g, "").toUpperCase();
        input.val(value);
      });
  }

  prepareData(options) {
    let country = this.getValue("address_country"),
      firstName = this.getValue("first_name"),
      lastName = this.getValue("last_name"),
      address, person;

    let data = {
      business_type: "individual",
      individual: {},

      tos_shown_and_accepted: true
    };

    if (country == "JP") {
      address = {
        address_kana: {
          postal_code: this.getValue("address_kana_postal_code"),
          state: this.getValue("address_kana_state"),
          city: this.getValue("address_kana_city"),
          town: this.getValue("address_kana_town"),
          line1: this.getValue("address_kana_line1"),
        },
        address_kanji: {
          postal_code: this.getValue("address_kanji_postal_code"),
          state: this.getValue("address_kanji_state"),
          city: this.getValue("address_kanji_city"),
          town: this.getValue("address_kanji_town"),
          line1: this.getValue("address_kanji_line1"),
        },
      };
      person = {
        first_name_kana: this.getValue("first_name_kana"),
        last_name_kana: this.getValue("last_name_kana"),
        first_name_kanji: this.getValue("first_name_kanji"),
        last_name_kanji: this.getValue("last_name_kanji"),
        email: this.getValue("email"),
        phone: this.getValue("phone")
      };
      if (!options.update) {
        $.extend(person, {
          dob: {
            day: this.getDateValue("birth_date", "day"),
            month: this.getDateValue("birth_date", "month"),
            year: this.getDateValue("birth_date", "year"),
          },
          gender: this.getValue("gender")
        });
      }
    } else {
      address = {
        address: {
          city: this.getValue("address_city"),
          state: this.getValue("address_state"),
          country: this.getValue("address_country"),
          postal_code: this.getValue("address_postal_code"),
          line1: this.getValue("address_line1"),
        }
      };
      if (["PR"].includes(country)) {
        address.address.country = "US";
        address.address.state = country;
      }
      person = {
        first_name: firstName,
        last_name: lastName,
        phone: this.getValue("phone"),
        email: this.getValue("email"),
        id_number: ["US", "CA", "HK", "SG", "PR", "MX"].includes(country) ? this.getValue("id_number") : null,
        ssn_last_4: ["US", "PR"].includes(country) ? this.getValue("ssn_last_4") : null,
      };
      if (!options.update) {
        $.extend(person, {
          dob: {
            day: this.getDateValue("birth_date", "day"),
            month: this.getDateValue("birth_date", "month"),
            year: this.getDateValue("birth_date", "year"),
          }
        });
      }
    }
    $.extend(data.individual, address, person);
    return data;
  }

  addressCountryChanged() {
    let showElement = function (el, show) {
      if (show) {
        $(el).find("input, select").prop("disabled", false);
        $(el).show();
      } else {
        $(el).find("input, select").prop("disabled", true);
        $(el).hide();
      }
    };
    let country = $("#stripe_account_form_address_country").val();
    if (country) {
      if ($("#stripe-terms-link").length > 0) {
        $("#stripe-terms-link").attr("href", $("#stripe-terms-link").data("terms-url").replaceAll("COUNTRY", country.toLowerCase()));
      }
      $(".address-lines").show();
      $(".country-dependent").each(function () {
        let only = $(this).data("country-only");
        let except = $(this).data("country-except");
        if (only) {
          showElement(this, only.includes(country));
        }
        if (except) {
          showElement(this, !except.includes(country));
        }
      });
      $("label.error").hide();
    } else {
      $(".address-lines").hide();
      $(".country-dependent").hide();
    }
    this.update_bank_number_form(country);
    if (options.update) {
      $("input[stripe-bank-account-ready]").prop("disabled", true);
    }
  }

  init(options) {
    this.add_validators();
    this.addressCountryChanged();
    $("#stripe-europe-name").addClass("country-dependent");
    $("#stripe-account-form").validate({
      submitHandler: function (form) {
        this.showError("");
        this.toggleButtonLoader(true);
        this.removeSpaces();
        stripeFormData = $(form).serializeArray();
        let data = this.prepareData(options),
          documentFrontEl = $("#stripe_account_form_document_front"),
          documentFront = documentFrontEl.length > 0,
          documentBackEl = $("#stripe_account_form_document_back"),
          documentBack = documentBackEl.length > 0,
          additionalDocumentFrontEl = $("#stripe_account_form_additional_document_front"),
          additionalDocumentFront = additionalDocumentFrontEl.length > 0,
          additionalDocumentBackEl = $("#stripe_account_form_additional_document_back"),
          additionalDocumentBack = additionalDocumentBackEl.length > 0,
          fileElements = {};

        let stripeData = {
          data: data,
          success: function (token) {
            if (!token?.id) {
              this.toggleButtonLoader(false);
              this.showError("Stripe did not return a valid account token. Please verify the address and try again.");
              return;
            }

            $("#stripe_account_form_token").val(token.id);
            this.submitForm(form);
          }.bind(this),
          error: function (error) {
            this.toggleButtonLoader(false);
            this.showError(options.error_nofication.replaceAll("%{message}", error.message));
          }.bind(this)
        };
        if (documentFront) {
          fileElements.documentFront = documentFrontEl[0].files[0];
        }
        if (documentBack) {
          fileElements.documentBack = documentBackEl[0].files[0];
        }
        if (additionalDocumentFront) {
          fileElements.additionalDocumentFront = additionalDocumentFrontEl[0].files[0];
        }
        if (additionalDocumentBack) {
          fileElements.additionalDocumentBack = additionalDocumentBackEl[0].files[0];
        }
        if (documentFront || additionalDocumentFront) {
          this.stripeUploadFiles({
            fileElements: fileElements,
            fileCallback: (fileData) => {
              let verification = {
                verification: {
                  document: {},
                  additional_document: {}
                }
              };
              if (fileData.documentFront) {
                verification.verification.document.front = fileData.documentFront.id;
              }
              if (fileData.documentBack) {
                verification.verification.document.back = fileData.documentBack.id;
              }
              if (fileData.additionalDocumentFront) {
                verification.verification.additional_document.front = fileData.additionalDocumentFront.id;
              }
              if (fileData.additionalDocumentBack) {
                verification.verification.additional_document.back = fileData.additionalDocumentBack.id;
              }
              $.extend(data.individual, verification);
              this.stripeToken(stripeData);
            }
          });
        } else {
          this.stripeToken(stripeData);
        }
      }.bind(this), errorPlacement: function (error, element) {
        error.appendTo(element.parent().parent());
      }
    });
    $("#update_also_bank_account").on("change", function () {
      let inputs = $("input[stripe-bank-account-ready]");
      if ($(this).is(":checked")) {
        inputs.filter(":visible").prop("disabled", false);
      } else {
        inputs.prop("disabled", true);
      }
    });
  }

  add_validators() {
    $.validator.addMethod(
      "country_regexp",
      function (value, element, field) {
        let country = $("#stripe_account_form_address_country").val();
        let rule = BANK_RULES[country] || {};
        let re = rule[field]?.regexp;
        if (globalThis.ITOONS.stripe_test_api_mode) {
          re = rule[field]?.test_regexp;
        }
        if (re) {
          let rx = new RegExp("^" + re + "$");
          let testValue = value.replaceAll(/\s+/g, "").toUpperCase();
          return rx.test(testValue);
        }
        return this.optional(element) || $(element).val();
      },
      function (field, element) {
        let country = $("#stripe_account_form_address_country").val();
        let rule = BANK_RULES[country] || {};
        let title = rule[field]?.title;
        let regexp = rule[field]?.regexp;
        if (globalThis.ITOONS.stripe_test_api_mode) {
          regexp = rule[field]?.test_regexp;
        }
        let def_title = field == "account_number" ? this.i18n_label(field, "Account number") : field;
        return this.i18n_label(title, def_title) + " " + this.i18n_label("must_match", "must be in the following format:") + " " + explain_regexp(regexp, this);
      }.bind(this)
    );
    // Canada
    $.validator.addMethod(
      "ca-social-insurance-number",
      function (value, element, field) {
        let sin = new SocialInsuranceNumber(value);
        return sin.isValid();
      }
    );
  }

  showError(message) {
    const errorElement = document.querySelector("#payout_error .payout-error");
    if (!errorElement) return;

    errorElement.textContent = message || "";
    errorElement.classList.toggle("d-none", !message);
    if (message) errorElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }



  stripeUploadFiles(options) {
    let uploadFiles = function uploadFiles() {
      let fileData, itemKey, fileForm, fileResult;
      return regeneratorRuntime.async(function uploadFiles$(_context) {
        while (1) {
          _context.prev = _context.next;
          switch (_context.prev) {
            case 0: {
              fileData = {};
              _context.t0 = regeneratorRuntime.keys(options.fileElements);
              return _context.t0;
            }
            case 2: {
              _context.t1 = _context.t0();
              if (_context.t1.done) {
                _context.next = 17;
                break;
              }

              itemKey = _context.t1.value;
              let fileElement = options.fileElements[itemKey];
              fileForm = new FormData();
              fileForm.append("file", fileElement);
              fileForm.append("purpose", "identity_document");
              _context.next = 11;
              return regeneratorRuntime.awrap(fetch("https://uploads.stripe.com/v1/files", {
                method: "POST",
                headers: {
                  "Authorization": "Bearer " + stripeApi._apiKey
                },
                body: fileForm
              }));
            }
            case 11: {
              fileResult = _context.sent;
              _context.next = 14;
              return regeneratorRuntime.awrap(fileResult.json());
            }
            case 14: {
              fileData[itemKey] = _context.sent;
              _context.next = 2;
              break;
            }
            case 17: {
              return _context.abrupt("return", fileData);
            }
            case 18:
            case "end":
              return _context.stop();
          }
        }
      });
    };

    uploadFiles()
      .then(function (data) {
        const failedUpload = Object.values(data).find(file => file?.error || !file?.id);
        if (failedUpload) {
          throw new Error(failedUpload.error?.message || "A verification document could not be uploaded.");
        }
        options.fileCallback(data);
      })
      .catch(error => {
        this.toggleButtonLoader(false);
        this.showError(error?.message || "A verification document could not be uploaded. Please try again.");
      });
  }

  async stripeToken(options) {
    try {
      const result = await stripeApi.createToken(
        "account",
        this.omitNullDeep(options.data)
      );

      if (result?.error) return options.error(result.error);
      if (result?.token?.id) return options.success(result.token);

      return options.error(
        new Error("Stripe did not return a valid account token. Please verify the submitted details.")
      );
    } catch (error) {
      return options.error(error);
    }
  }

  submitForm(form) {
    let url = form.getAttribute("action");
    let data = new FormData(form);
    fetch(url, {
      method: data.get("_method") || "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: $(form).serialize(),
    })
      .then(async r => {
        const response = await r.text();
        const contentType = r.headers.get("content-type") || "";

        if (!contentType.includes("text/vnd.turbo-stream.html") || !response.trim()) {
          throw new Error("We could not save the bank account. Please try again.");
        }

        Turbo.renderStreamMessage(response);
        this.toggleButtonLoader(false);
      })
      .catch(error => {
        this.toggleButtonLoader(false);
        this.showError(error?.message || "We could not save the bank account. Please try again.");
        console.error(error);
      });
  }

  toggleButtonLoader(isLoading) {
    const $button = $(this.element).find("#str-form-sub-btn");
    $button.prop("disabled", isLoading);
    $button.find(".btn-text").attr("style", isLoading ? "display:none !important;" : "");
    $button.find(".button-loader-spinner").toggleClass("d-none", !isLoading);
    $(this.element).toggleClass("disabled-form", isLoading);
  }
}

function explain_regexp(value, cuObj) {
  let t = value;
  t = t.replaceAll("-[", ";" + cuObj.i18n_label("a_dash", "a dash") + ";[");
  t = t.replaceAll(/\[0-9\]\{(\d+)}/g, ";$1 " + cuObj.i18n_label("digits", "digits") + ";");
  t = t.replaceAll(/\[A-Z0-9\]\{(\d+)}/g, ";$1 " + cuObj.i18n_label("digits_or_chars", "digits or chars") + ";");
  t = t.replaceAll(/\[0-9\]\{(\d+),(\d+)}/g, ";$1-$2 " + cuObj.i18n_label("digits", "digits") + ";");
  t = t.replaceAll(/\[A-Z0-9\]\{(\d+),(\d+)}/g, ";$1-$2 " + cuObj.i18n_label("digits_or_chars", "digits or chars") + ";");
  t = t.replaceAll(/\[A-Z\]\{(\d+)}/g, ";$1 letter country code;");
  t = t.replaceAll(/;+/g, ", ").replace(/^,\s*/, "").replace(/,\s*$/, "");
  return t;
}
